import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

import MainLayout from "@/components/Layout/MainLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FormationsPage from "@/pages/FormationsPage";
import FormationDetail from "@/pages/FormationDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import GuideIA from "@/pages/GuideIA";
import GuidePost from "@/pages/GuidePost";
import MentionsLegales from "@/pages/MentionsLegales";
import CertificatQualiopi from "@/pages/CertificatQualiopi";
import ProtectionDonnees from "@/pages/ProtectionDonnees";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <HelmetProvider>
      <div className="App font-body">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Home />} />
              <Route path="formations" element={<FormationsPage />} />
              <Route path="formations/:slug" element={<FormationDetail />} />
              <Route path="a-propos" element={<About />} />
              <Route path="contact" element={<Contact />} />
              <Route path="blog" element={<Blog />} />
              <Route path="blog/:slug" element={<BlogPost />} />
              <Route path="guide-ia" element={<GuideIA />} />
              <Route path="guide-ia/:slug" element={<GuidePost />} />
              <Route path="mentions-legales" element={<MentionsLegales />} />
              <Route path="certificat-qualiopi" element={<CertificatQualiopi />} />
              <Route path="protection-donnees" element={<ProtectionDonnees />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
